import { jsx as _jsx } from "react/jsx-runtime";
import { isAndroid, isIOS } from 'react-device-detect';
import { BroadcasterView } from '../components/views/BroadcasterView';
import { BroadcasterViewMobile } from '../components/views/BroadcasterViewMobile';
import { EmbeddedView } from '../components/views/EmbeddedView';
import { ViewerView } from '../components/views/ViewerView';
import { ViewerViewMobile } from '../components/views/ViewerViewMobile';
import { useStreamDirection } from '../state/streamState';
import { useRequiredParam } from '../utils/url';
export function StreamPage({ embedded }) {
    const streamPartId = useRequiredParam('streamPartId');
    const streamDirection = useStreamDirection(streamPartId);
    if (streamDirection === 'outgoing') {
        if (isIOS || isAndroid) {
            return _jsx(BroadcasterViewMobile, { streamPartId: streamPartId });
        }
        return _jsx(BroadcasterView, { streamPartId: streamPartId });
    }
    if (embedded) {
        return _jsx(EmbeddedView, { streamPartId: streamPartId });
    }
    if (isIOS || isAndroid) {
        return _jsx(ViewerViewMobile, { streamPartId: streamPartId });
    }
    return _jsx(ViewerView, { streamPartId: streamPartId });
}
